export default "__VITE_ASSET__CTfpO4Bw__"